import axios from '../../../axios';
import { IShareJobWithTeam } from '../../JobSettingService/types/jobCloseReasonDTO';
import { IcandidateSummary, IPrompt, scopeType } from '../types/iPromptDTO';

const url = '/api/jobs/';

const jobUrl = '/jobsearch/api/jobs/';

export const downloadJobDescription = (jobId: string) =>
  axios.get(`${url}download/${jobId}`, { responseType: 'arraybuffer' });

export const shareJobWithTeam = (shareJobWithTeam: IShareJobWithTeam) =>
  axios.put('jobsearch/api/jobs/team/share', shareJobWithTeam);

export const fetchQuestionsForJob = (jobId: string) =>
  axios.get(`${jobUrl}fetch/questions/${jobId}`);

export const fetchQuestionsForJobDescription = (description: string) =>
  axios.post(`${jobUrl}fetch/questions`, { JD: description });

export const fetchChatGPTPrompt = (recruiterId: string) =>
  axios.get(`${jobUrl}fetch/prompt/${recruiterId}`);

export const createChatGPTPrompt = (promptData: IPrompt[]) =>
  axios.post(`${jobUrl}fetch/prompt/`, promptData);

export const getChatGPTResponseByScope = (scope: scopeType) =>
  axios.get(`${jobUrl}chatgpt/fetch-prompt-by-scope/${scope}`);

export const fetchCandidateResponse = (payload: IcandidateSummary) =>
  axios.post(`${jobUrl}fetch/candidateSummary`, payload);
